import { createActions } from 'redux-actions';

export const childActions = createActions(
  {
    GET: (payload) => payload,
    SET: (payload) => payload,
    CREATE: (payload) => payload,
    UPDATE: (payload) => payload,
    ADD_NOTE: (action) => action,
  },
  {
    prefix: 'Profile/CHILD',
  }
);

export default childActions;
